const reducer = (state, action) => {
  let nextState = Object.assign({}, state);

  switch(action.type) {
    case 'GENERAL.RESET':
      nextState = action.payload;
      return nextState;

    case 'GENERAL.IS_LOGGED_IN':
      nextState.isLoggedIn = action.payload;
      return nextState;

    case 'GENERAL.TAB':
      nextState.tab = action.payload;
      return nextState;

    case 'GENERAL.ADD_BASIC_IDS':
      nextState.basicIds = [...new Set([...nextState.basicIds, ...action.payload])];
      return nextState;

    default: return nextState;
  }
}

export { reducer };